export default __webpack_public_path__ + "static/media/posao_hr.1a1e8c7b.png";